import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ODataProviderService, ODataFactory, ODataService } from './odata-provider.service';
import { Observable } from 'rxjs/Rx';

export class ODataBrServiceBase {
    token: string = "";
    private urlHost: string = "";
    private urlPort: number = 0;
    headers: HttpHeaders;
    mudouURL: boolean = false;

    port(aPort: number) {
        this.urlPort = aPort;
        this.mudouURL = true;
        return this;
    }
    host(aHost: string) {
        this.urlHost = aHost;
        this.mudouURL = true;
        return this;
    }
    getUrl() {
        let base = this.urlHost + ':' + this.urlPort;
        return base;
    }
    getJson(url: string): Observable<any> {
        this.configOptions();
        return this._odata.getJson(url);
    }
    getOData(query: ODataService): ODataProviderService {
        this.configOptions();
        return this._odata.getValue(query);
    }
    public configOptions() {
        if (this.token != "") {
            this._odata.token = this.token;
        };
        if (this.mudouURL) {
            this._odata.createUrlBase(this.urlHost, this.urlPort);
            this.mudouURL = false;
        } else {
            this.urlHost = this._odata.config.server.host;
            this.urlPort = this._odata.config.server.port;
            this._odata.createUrlBase(this.urlHost, this.urlPort);
        }
        if (this.headers.keys().length > 0) {
            for (let item of this.headers.keys()) {
                this._odata.headers.set(item, this.headers.get(item));
            }
        }
    }

    constructor(public _odata: ODataProviderService) {
        this.headers = new HttpHeaders();
    }

    public load() {

    }
    notify( eventNotify ){
        this._odata.notify(eventNotify);
    }

    getItem(query: ODataService): ODataProviderService {
        this.configOptions();
        return this._odata.getValue(query);
    }
    postItem(resource: string, item: any, erroProc: any = null): Observable<any> {
        this.configOptions();
        return this._odata.postItem(resource, item, erroProc);
    }

    putItem(resource: string, item: any, erroProc: any = null): Observable<any> {
        this.configOptions();
        return this._odata.putItem(resource, item, erroProc);
    }

    deleteItem(resource: string, item: any, erroProc: any = null): Observable<any> {
        this.configOptions();
        return this._odata.deleteItem(resource, item, erroProc);
    }

    patchItem(resource: string, item: any, erroProc: any = null): Observable<any> {
        this.configOptions();
        return this._odata.patchItem(resource, item, erroProc);
    }

}